import { graphql } from "@/lib/gql/__generated__";

export const Hotel_HotelInfoSettingsPage_Query = graphql(`
	query Hotel_HotelInfoSettingsPage($hotelID: ID!) {
		hotel(hotelID: $hotelID) {
			id
			companyID
			hotelID
			inSale
			email
			tel
			name
			catchCopy
			customTypeRoomTitle
			facebookURL
			instagramURL
			twitterURL
			threadsURL
			lineURL
			address {
				nationality
				postalCode
				state
				pref
				city
				town
				other
			}
			geoLocation {
				lat
				lon
			}
			logoImage {
				bucket
				key
				region
				mimeType
				fileName
			}
			mainKeyVisual {
				bucket
				key
				region
				mimeType
				fileName
			}
			keyVisuals {
				bucket
				key
				region
				mimeType
				fileName
			}
		}
	}
`);
